import { render, staticRenderFns } from "./position-auth-update.vue?vue&type=template&id=5c67f233"
import script from "./position-auth-update.vue?vue&type=script&lang=js"
export * from "./position-auth-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports